<script>
	import './index.scss';
	import { pkgBrief } from "../store.js";

	function addPkg(type) {
		let newArray = {
			type: type,
			content: "",
			detail: ""
		};
		$pkgBrief = [...$pkgBrief, newArray];
	};

</script>

<div class="dropdown">
	<div class="dropdown-trigger">
		<button class="button is-outlined is-light" aria-haspopup="true" aria-controls="dropdown-menu">
			<span>Add Element</span>
			<span class="icon is-small">
				<i class="fas fa-plus" aria-hidden="true"> </i>
			</span>
		</button>
	</div>
	<div class="dropdown-menu" id="dropdown-menu" role="menu">
		<div class="dropdown-content has-background-dark">
			<a class="dropdown-item has-text-white" on:click={() => addPkg(1)}>
				<span class="icon is-small">
					<i class="fas fa-paragraph" aria-hidden="true"> </i>
				</span> &nbsp;
				Text
			</a>
			<a  class="dropdown-item has-text-white" on:click={() => addPkg(2)}>
				<span class="icon is-small">
					<i class="fas fa-image" aria-hidden="true"> </i>
				</span> &nbsp;
				Image
			</a>
			<a class="dropdown-item has-text-white" on:click={() => addPkg(3)}>
				<span class="icon is-small">
					<i class="fas fa-calendar" aria-hidden="true"> </i>
				</span> &nbsp;
				Date
			</a>
			<hr class="dropdown-divider">
			<a class="dropdown-item has-text-white" on:click={() => addPkg(0)}>
				<span class="icon is-small">
					<i class="fas fa-heading" aria-hidden="true"> </i>
				</span> &nbsp;
				Title
			</a>
		</div>
	</div>
</div>